angular.module('zc').component('zcDashboardDeviceDistributionChart', {
  templateUrl: '/templates/projects.dashboard/device_distribution_chart.html',
  bindings: {
    project: '<',
    chart: '<',
  },
  controller: zcDashboardDeviceDistributionChartController
});

zcDashboardDeviceDistributionChartController.$inject = [
  '$scope',
  '$translate',
  '$window',
  'ChartV2',
  'pieChartV2Config'
];

function zcDashboardDeviceDistributionChartController($scope, $translate, $window, ChartV2, pieChartV2Config) {
  const vm = this;
  vm.deliveryRates = {
    pc: 0,
    sp: 0,
    tablet: 0,
  };

  $scope.$watch('$ctrl.project', project => {
    if(!project || !project.thisMonthStat) return;
    setChartConfig();
  });

  function setChartConfig() {
    const totalSessionCount = vm.project.thisMonthStat.all_campaign.session_count;

    _.each(vm.project.thisMonthStat.devices, deviceStats => {
      vm.deliveryRates[deviceStats.device] = deviceStats.session_count / totalSessionCount * 100;
    });

    const devices = [
      [$translate.instant('projectsDashboard.deviceDistributionChart.pc'), vm.deliveryRates.pc],
      [$translate.instant('projectsDashboard.deviceDistributionChart.sp'), vm.deliveryRates.sp],
      [$translate.instant('projectsDashboard.deviceDistributionChart.tablet'), vm.deliveryRates.tablet],
    ];

    const chart = new ChartV2(pieChartV2Config);

    chart.addSeries({
      type: 'pie',
      name: $translate.instant('projectsDashboard.deviceDistributionChart.device'),
      innerSize: '50%',
      data: devices
    });

    vm.chartConfig = chart.getConfig();
    _.merge(vm.chartConfig.options, {
      chart: {
        width: vm.chart.chart_width,
        height: vm.chart.chart_height,
      },
      legend: {
        enabled: true,
        align: 'right',
        layout: 'vertical',
        verticalAlign: 'middle',
        itemMarginTop: 15,
        labelFormatter() {
          const percentage = $window.Highcharts.numberFormat(this.percentage, 2);
          return `<div style="margin-top: -12px;">
            ${this.name} <span class="u-color-babyblue o-type-xl">${percentage}</span> %
          </div>`;
        },
        useHTML: true,
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
          tooltip: {
            valueSuffix: ' %',
            valueDecimals: 1
          },
        },
      },
    });

  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.dashboard/device_distribution_chart.controller.js